import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import './TrialBanner.css'

const DAY = 86_400_000
/** Uyarının başladığı gün sayısı: sürenin tamamında değil, sonuna doğru. */
const WARN_DAYS = 3

/**
 * Deneme süresinin sonuna yaklaşan ya da geçen kurumun patronuna, her
 * sayfanın üstünde. Kalıcı kurumda ve denemenin ilk günlerinde hiç yok.
 *
 * Yalnızca patron: süreyi uzatmak onun işi. Personel süre dolunca kasada
 * zaten "yeni sipariş alınamıyor" kutusunu görüyor.
 */
export function TrialBanner() {
  const { isOwner, trialEndsAt, trialExpired, tenantId, payLocked, payLate, payStatus } = useAuth()

  // Abonelik ödemesi (2 Kas 2026). Kapandıysa herkese: personel de neden
  // sipariş giremediğini bilsin. Gecikip henüz kapanmadıysa yalnız patrona.
  if (payLocked) {
    return (
      <div className="trial is-over" role="status">
        <strong>Hesap salt okunur</strong>
        <span>
          {isOwner
            ? 'Abonelik ödemesi gecikti, yeni sipariş alınamıyor. Verileriniz ve raporlarınız duruyor; ödeme alındığında hemen açılır.'
            : 'Yeni sipariş alınamıyor. İşletme yöneticinize başvurun.'}
        </span>
      </div>
    )
  }
  if (payLate && isOwner && payStatus?.lockedSince) {
    return (
      <div className="trial" role="status">
        <strong>Abonelik ödeme günü geçti</strong>
        <span>
          {new Date(`${payStatus.lockedSince}T12:00:00`).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' })}{' '}
          tarihine kadar ödenmezse hesap salt okunur olur, yeni sipariş alınamaz.
        </span>
      </div>
    )
  }

  if (!isOwner || trialEndsAt === null) return null

  const left = Math.ceil((trialEndsAt - Date.now()) / DAY)
  if (!trialExpired && left > WARN_DAYS) return null

  return (
    <div className={`trial ${trialExpired ? 'is-over' : ''}`} role="status">
      <strong>
        {trialExpired
          ? 'Deneme süreniz doldu'
          : left <= 1
            ? 'Deneme süreniz yarın bitiyor'
            : `Deneme sürenizin bitmesine ${left} gün kaldı`}
      </strong>
      <span>
        {trialExpired
          ? 'Yeni sipariş alınamıyor; verileriniz ve raporlarınız duruyor.'
          : 'Süre dolunca kasa yeni sipariş almaz; verileriniz silinmez.'}{' '}
        Devam etmek için{' '}
        <Link to={`/${tenantId}/ayarlar?bolum=hesap`} className="trial__link">
          Ayarlar &gt; Hesabım
        </Link>
        'dan talep gönderin.
      </span>
    </div>
  )
}
